import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import {
  adminRoute,
  publicAdminRoutes,
  privateAdminRoutes,
  userRoute,
  contactusRoute,
  policyRoute,
  licenseAgreementRoute,
} from './utils/constants/route';
import { AdminMainLayout } from './layouts';
import { ToastContainer } from 'react-toastify';
import { ContactUs } from './pages';
import { Policy } from './pages';
import LicenseAgreement from './pages/admin/license-agreement/licenseAgreement';

type Props = {};

const App = (props: Props) => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin public route */}
        <Route path={contactusRoute.base} element={<ContactUs />} />
        <Route path={userRoute.base} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>
        <Route path={adminRoute.base} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>
        <Route path={adminRoute.base}>
          {publicAdminRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
        {/* Private route */}
        <Route path={adminRoute.base} element={<AdminMainLayout />}>
          {privateAdminRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
        <Route path={policyRoute.base} element={<Policy />} />
        <Route path={licenseAgreementRoute.base} element={<LicenseAgreement />} />
      </Routes>
      <ToastContainer newestOnTop autoClose={5000} theme='light' limit={1} />
    </BrowserRouter>
  );
};

export default App;
